// portal-payment.component.ts

import { Title } from '@angular/platform-browser';
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import {
  PortalViewPageStatusEnum,
  SharedPortalViewService,
} from '../shared-portal-view.service';
import { Store } from '@ngrx/store';
import { websitePaymentGatewaysActions } from 'src/app/shared/store/_features/website/payments/website-payments.actions';

@Component({
  selector: 'app-portal-payment',
  templateUrl: './portal-payment.component.html',
  styleUrls: ['./portal-payment.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class PortalPaymentComponent implements OnInit {
  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    private title: Title,
    private store: Store
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.payment
    );
    this.getPaymentGateways()
  }

  ngOnInit(): void {
    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
      ' > ' +
      'Payment Methods'
    );
  }

  getPaymentGateways() {
    this.store.dispatch(websitePaymentGatewaysActions.load());
  }
}
